import { createAsyncThunk } from "@reduxjs/toolkit";
import { Deal } from "@ifgengineering/client-invest-sdk";
import { logException } from "@helpers/logException/logException";
import { clientInvestSdk } from "@utils/clientInvestSdk";

const FETCH_DEALS_API = "FETCH_DEALS_API";
const FETCH_IF_ISA_LIVE_DEALS_API = "FETCH_IF_ISA_LIVE_DEALS_API";
const FETCH_IF_ISA_TRANSFER_DESTINATIONS_API =
  "FETCH_IF_ISA_TRANSFER_DESTINATIONS_API";

export const fetchDealsAPI = createAsyncThunk<Deal[]>(
  FETCH_DEALS_API,
  async () => {
    try {
      const response = await clientInvestSdk.getDeals({
        sortBy: "expiryDate:asc",
      });

      return response.data;
    } catch (e: any) {
      if (e.response.status !== 401) {
        logException({
          tag: "fetchDealsAPI",
          exception: e,
        });
      }

      return [];
    }
  }
);

export const fetchIfIsaLiveDealsAPI = createAsyncThunk<Deal[]>(
  FETCH_IF_ISA_LIVE_DEALS_API,
  async () => {
    try {
      const response = await clientInvestSdk.getIfIsaLiveDeals();

      return response.data;
    } catch (e: any) {
      if (e.response?.status !== 401) {
        logException({
          tag: "fetchIfIsaLiveDealsAPI",
          exception: e,
        });
      }

      return [];
    }
  }
);

export const fetchIfIsaTransferDestinationsAPI = createAsyncThunk<Deal[]>(
  FETCH_IF_ISA_TRANSFER_DESTINATIONS_API,
  async () => {
    try {
      const response = await clientInvestSdk.getIfIsaTransferDestinations();

      return response.data;
    } catch (e: any) {
      if (e.response?.status !== 401) {
        logException({
          tag: "fetchIfIsaTransferDestinationsAPI",
          exception: e,
        });
      }

      return [];
    }
  }
);
